import { render, staticRenderFns } from "./NumRender.vue?vue&type=template&id=0f193970&"
import script from "./NumRender.vue?vue&type=script&lang=ts&"
export * from "./NumRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports